import type { TranslationKeys } from '@/@types/keys/translation'

export type BotEnvironment = 'dev' | 'stg' | 'prd'

const ENV_ORDER: BotEnvironment[] = ['dev', 'stg', 'prd']

export const ENV_TRANSLATION_KEY: Record<BotEnvironment, TranslationKeys> = {
  dev: 'botMigration.dialogs.create.environmentStep.environments.dev',
  stg: 'botMigration.dialogs.create.environmentStep.environments.staging',
  prd: 'botMigration.dialogs.create.environmentStep.environments.production',
}

export const ENV_BADGE_CLASSNAME: Record<BotEnvironment, string> = {
  dev: 'bg-[#d7f1dc] text-[#356f42] hover:bg-[#d7f1dc]',
  stg: 'bg-[#e0e0fa] text-[#5b57db] hover:bg-[#e0e0fa]',
  prd: 'bg-[#fcc7d5] text-[#952e48] hover:bg-[#fcc7d5]',
}

export function getBotEnvironment(botName: string): BotEnvironment {
  const suffix = botName?.toLowerCase()?.split('-')?.pop() ?? ''

  if (suffix.includes('dev')) {
    return 'dev'
  }

  if (suffix.includes('stg') || suffix.includes('staging')) {
    return 'stg'
  }

  if (suffix.includes('prd') || suffix.includes('prod')) {
    return 'prd'
  }

  return 'dev'
}

export function getAvailableTargets(source: BotEnvironment): BotEnvironment[] {
  return ENV_ORDER.filter((env) => env !== source)
}

export function getDefaultTarget(source: BotEnvironment): BotEnvironment {
  return getAvailableTargets(source)[0]
}

export function buildTargetBotName(
  sourceBotName: string,
  target: BotEnvironment,
): string {
  const parts = sourceBotName.split('-')

  if (parts.length < 2) {
    return `${sourceBotName}-${target}`
  }

  parts[parts.length - 1] = target
  return parts.join('-')
}
